<template>
  <div class="navigation">
    <v-container>
      <Widget v-if="layout == 'empty'" position="MainMenu"/>
      <Widget v-else-if="layout == 'auth'" position="menu_profile"/>
    </v-container>
  </div>
</template>

<script>
import Widget from '@/components/app/Widget'

export default {
  components: {
    Widget
  },
  props: {
    layout: String
  },
  data: () => ({})
}
</script>
